import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import React from "react";

export const Recognition: React.FC = () => {
  return (
    <div id="recognition">
      <Box marginBottom={4}>
        <Typography
          marginBottom={5}
          fontWeight="bold"
          fontSize="3rem"
          sx={{textAlign: {md: "start", sm: "center"}}}
        >
          Recognition and Partnership
        </Typography>
        <Stack
          direction="column"
          spacing={4}
          sx={{textAlign: {md: "start", sm: "center"}}}
        >
          <Box>
            <Typography
              fontSize="24px"
              fontWeight={"bold"}
              color="secondary"
              mb={3}
            >
              Industry Awards
            </Typography>
            <Grid container direction="row">
              <Grid item md={4} sm={12} mb={3}>
                <Stack
                  direction="column"
                  sx={{alignItems: "center", textAlign: "center"}}
                >
                  <Box
                    component="img"
                    height="100px"
                    alt=""
                    src="/smart-retail-tech-award-2022.jpeg"
                  />
                  <Box>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                      fontWeight="bold"
                    >
                      HKRMA
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                    >
                      Smart Retail Tech Gold Award
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                    >
                      2022
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={4} sm={12} mb={3}>
                <Stack
                  direction="column"
                  sx={{alignItems: "center", textAlign: "center"}}
                >
                  <Box
                    component="img"
                    height="100px"
                    alt=""
                    src="/innovative-smart-solution-award-2022.jpeg"
                  />
                  <Box>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                      fontWeight="bold"
                    >
                      HKRMA
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                    >
                      Innovative Smart Solution Award
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                    >
                      2022
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
              <Grid item md={4} sm={12} mb={3}>
                <Stack
                  direction="column"
                  sx={{alignItems: "center", textAlign: "center"}}
                >
                  <Box
                    component="img"
                    height="100px"
                    alt=""
                    src="/retail-innovation-award-2021.png"
                  />
                  <Box>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                      fontWeight="bold"
                    >
                      HKRMA
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                    >
                      Innovative Smart Solution Award
                    </Typography>
                    <Typography
                      component="span"
                      variant="body2"
                      display="block"
                    >
                      2021
                    </Typography>
                  </Box>
                </Stack>
              </Grid>
            </Grid>
          </Box>
          <Box>
            <Typography
              fontSize="24px"
              fontWeight={"bold"}
              color="secondary"
              marginBottom={2}
            >
              Media Presence
            </Typography>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignItems="center"
            >
              <Box
                px={2}
                component="img"
                width="90%"
                alt=""
                src="/retail-award-news-2022.png"
              />
            </Grid>
          </Box>
          <Box>
            <Typography
              fontSize="24px"
              fontWeight={"bold"}
              color="secondary"
              marginBottom={2}
            >
              Partnership and Support
            </Typography>
            <Grid
              container
              direction="row"
              justifyContent="center"
              alignContent="center"
            >
              <Grid
                container
                item
                md={6}
                sm={12}
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
                mb={3}
              >
                <Grid
                  item
                  component="img"
                  sx={{
                    height: "100px",
                  }}
                  alt=""
                  src="/hkstp-logo.png"
                />
              </Grid>
              <Grid
                container
                item
                md={6}
                sm={12}
                sx={{
                  alignItems: "center",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
                mb={3}
              >
                <Grid
                  item
                  component="img"
                  sx={{
                    height: "100px",
                  }}
                  alt=""
                  src="/hkstp-incuapp.png"
                />
              </Grid>
            </Grid>
          </Box>
        </Stack>
      </Box>
    </div>
  );
};
